module.exports = {"goodmorning":"Good Morning","goodday":"Hope you are having a good day"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 202
// module chunks = 0